// extracted by mini-css-extract-plugin
export default {"root":"PriceArea-root_Iuats"};